"use client";
import { jsx as e } from "react/jsx-runtime";
import { s as r } from "../../Author.module-DO0Qr1K7.mjs";
const l = ({ label: t }) => t ? /* @__PURE__ */ e("div", { className: r.createdByLabel, "data-testid": "author-label", children: t }) : null;
export {
  l as AuthorLabel
};
//# sourceMappingURL=AuthorLabel.es.js.map
